import clsx from 'clsx';
import React, { forwardRef } from 'react';

import Button, { ButtonProps } from '@components/Button';

type TopNavItemProps = ButtonProps & {
  showLeftDivider?: boolean;
  isScrollStyle?: boolean;
  liClassName?: string;
};

const TopNavItem = forwardRef<HTMLLIElement, TopNavItemProps>(
  ({ className, showLeftDivider, isScrollStyle, liClassName, ...rest }, ref) => (
    <li ref={ref} className={clsx(liClassName)}>
      <Button
        className={clsx(
          'relative block border-none bg-transparent py-12 font-suisse-intl-mono text-overline-md text-black transition-colors hover:text-primary-magenta focus:text-primary-magenta dark:text-white dark:hover:text-primary-pink',
          {
            'before:absolute before:-left-36 before:bottom-0 before:h-px before:w-36 before:origin-bottom-right before:rotate-[50deg] before:bg-black before:content-[""] dark:before:bg-[var(--light-grayscale-border)]':
              showLeftDivider,
            'px-4 py-[22px] text-white dark:text-white': isScrollStyle,
            'px-8': !isScrollStyle,
          },
          className
        )}
        {...rest}
      />
    </li>
  )
);

TopNavItem.displayName = 'TopNavItem';

export default TopNavItem;
